<template>
  <div class="card">
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert color="success" v-if="show_success" class="mx-2 mt-2"
        >{{ alert_msg }}
      </argon-alert>
      <div class="table-responsive p-0" v-if="customerList">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                Codice cliente
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                Ragione sociale
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Stato
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Data creazione
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="customer in customerList" :key="customer._id">
              <table-customer-row :item="customer" />
              <td class="align-middle">
                <a @click="editCustomer(customer._id)"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Modifica"
                  href="javascript:;">
                  <i class="fa fa-pen"></i>
                </a>
                <a @click.stop="openModal(customer._id)"
                  class="text-secondary font-weight-bold text-xs ms-2"
                  data-toggle="tooltip"
                  data-original-title="Elimina"
                  href="javascript:;">
                  <i class="fa fa-trash"></i>
                </a>
                <delete-modal
                  :modalId="'deleteModal' + customer._id"
                  :object="customer"
                  @deleteObject="deleteCustomer"
                  @closeModal="closeModal(customer._id)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import DeleteModal from "@/components/deleteModal.vue";
import axios from "axios";
import ArgonAlert from "@/components/ArgonAlert.vue";
import TableCustomerRow from "@/views/customer/tableCustomerRow.vue";

export default {
  name: "customer-table",
  props: {
    customers: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      show_success: false,
      alert_msg: "",
      customerList: {}
    };
  },
  components: { ArgonAlert, DeleteModal, TableCustomerRow },
  mounted() {
    this.customerList = this.customers;
  },
  methods: {
    editCustomer(customerId) {
      router.push({ name: "Modifica cliente", params: { id: customerId } });
    },
    openModal(id) {
      this.$vfm.open("deleteModal" + id);
    },
    async closeModal(id) {
      await router.push({ name: "Lista clienti" });
      await this.$vfm.close("deleteModal" + id);
    },
    async deleteCustomer(customer) {
      this.$emit("deleteObject", customer);
      const response = await axios.delete(
        this.$endpoint + "/customer/delete/" + customer._id,
        {
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        }
      );

      if (response.data.status === "OK") {
        this.show_success = true;
        this.alert_msg = "Cliente eliminato con successo";
        const index = this.customerList.findIndex(obj => obj._id === customer._id) // find the post index
        if (~index) // if the post exists in array
          this.customerList.splice(index, 1) //delete the post
      }

      await this.closeModal(customer._id);
    },
  },
};
</script>
